<script lang="ts" setup>
  import { computed, toRefs } from 'vue'

  import * as Icons from '@heroicons/vue/24/solid'
  import { pascalCase } from 'change-case'
  import type { RouteLocationRaw } from 'vue-router'

  interface Props {
    icon?: String | null
    position?: 'start' | 'end'
    to: RouteLocationRaw
    target?: 'blank' | '_blank'
    underline?: 'solid' | 'dashed' | undefined
  }

  const props = defineProps<Props>()

  const { icon, position, to, underline, target } = toRefs(props)
  const iconRef = computed(() => (icon.value ? (Icons as Record<string, string | object>)[`${pascalCase(icon.value)}Icon`] : undefined))
</script>
<template>
  <RouterLink
    :class="{ 'inline-flex items-center gap-x-1 leading-normal': icon, 'underline underline-offset-4': underline, 'decoration-dashed': underline == 'dashed' }"
    :target="target"
    :to="to"
    class="text-blue-700 font-semibold">
    <component
      :is="iconRef"
      v-if="icon && position !== 'end'"
      :class="'h-4 w-4'"
      aria-hidden="true" />
    <slot />
    <component
      :is="iconRef"
      v-if="icon && position === 'end'"
      :class="'h-4 w-4'"
      aria-hidden="true" />
  </RouterLink>
</template>
